import React from 'react';
import { WaitlistTopNav } from '../components/WaitlistTopNav';
import { Footer } from '../components/Footer';

export const PrivacyPage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <WaitlistTopNav />
    <div className="max-w-2xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Last updated: June 2024</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p>
        We collect information you provide directly to us, such as when you create an account, update your profile, or use our services. This may include your name, email address, and financial data.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Information</h2>
      <p>
        We use your information to provide, maintain, and improve our services, to communicate with you, and to protect our users.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Security</h2>
      <p>
        We implement reasonable security measures to protect your information. However, no method of transmission over the Internet is 100% secure.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">4. Sharing of Information</h2>
      <p>
        We do not share your personal information with third parties except as necessary to provide our services, comply with the law, or protect our rights.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Choices</h2>
      <p>
        You may update or delete your account information at any time by logging into your account.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">6. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at support@simpletracker.com.
      </p>
    </div>
    <Footer />
  </div>
); 